import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=63f0e6b8&"
import script from "./ChangePlan.vue?vue&type=script&lang=js&"
export * from "./ChangePlan.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports